import {DaysOffEmployeeStore, NewDayOffForm} from "./days-off-employee-store";
import {observer} from "mobx-react-lite";
import StandalonePopover from "../../components/ui/StandalonePopover";
import {Field, Form} from "react-final-form";
import {DateInput, Select} from "../../components/ui";
import {FinalButtonSet} from "../../components/ui/form";
import React from "react";
import {DayOffCreateFromMemberInput, DayOffReasonEnum} from "../../generated";
import {formatDayOffReasonEnum} from "../daysOffManage/format-day-off-reason-enum";

type Props = {
    store: DaysOffEmployeeStore;
}

export const DayOffEmployeeAskModal = observer((props: Props) => {
    const {store} = props;

    return <StandalonePopover
        title={'Request day off'}
        noGrid
        closePopover={() => store.closeModal()}
    >
        <Form<NewDayOffForm>
            onSubmit={(values) => {
                return store.submitNewDayOff(values)
            }}
            initialValues={{
                reason: DayOffReasonEnum.Holiday,
            }}
        >
            {({handleSubmit, pristine, submitting, values}) => (
                <form onSubmit={handleSubmit}>
                    <Field
                        label='Date'
                        name='date'
                        placeholder='Select date'
                        component={DateInput}
                    />

                    <Field
                        name='reason'
                        label='Reason'
                        placeholder='Select reason'
                        options={Object.values(DayOffReasonEnum)}
                        formatOptions={formatDayOffReasonEnum}
                        component={Select}
                    />

                    <FinalButtonSet disabled={!values['date']} submitting={submitting} pristine={pristine} mode={"RELATIVE"}/>
                </form>
            )}
        </Form>
    </StandalonePopover>
})